import React from 'react'
import styled from 'styled-components'

import CMS from '@talus-analytics/library.airtable-cms'
import useIndexPageData from 'cmsHooks/useIndexPageData'

import { Center } from 'components/layout'
import device from 'utilities/device'
interface GridChildProps {
  right?: boolean
}
const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 3rem;
  margin-top: 80px;
  margin-bottom: 120px;
  background-image: radial-gradient(#10333f 0%, rgba(16, 51, 63, 0) 75%);
  @media ${device.tablet} {
    display: flex;
    flex-direction: column;
    margin-top: 40px;
    margin-bottom: 80px;
  }
`
const TextContent = styled.div`
  max-width: 80%;
`
const Tagline = styled.h3`
  color: ${({ theme }) => theme.colorLightBlue};
  margin-bottom: 15px;
`
const Description = styled.p``
const ImageContainer = styled.div<GridChildProps>`
  max-width: 100%;
  ${props => props.right && 'grid-column: 2; grid-row: 1;'}
  @media ${device.tablet} {
    margin-bottom: 20px;
  }
`
const Text = styled(Center)<GridChildProps>`
  ${props => props.right && 'grid-column: 1; grid-row: 1;'}
`
interface FeatureProps {
  number: string
  imageOn: 'left' | 'right'
}
const Feature = ({ number, imageOn }: FeatureProps): JSX.Element => {
  const data = useIndexPageData()

  return (
    <Grid>
      <ImageContainer right={imageOn === 'right'}>
        <CMS.Image name={`How ${number} image`} data={data} />
      </ImageContainer>
      <Text cross right={imageOn === 'right'}>
        <TextContent>
          <Tagline>
            <CMS.Text name={`How ${number} tagline`} data={data} />
          </Tagline>
          <Description>
            <CMS.Text name={`How ${number} description`} data={data} />
          </Description>
        </TextContent>
      </Text>
    </Grid>
  )
}

export default Feature
